


























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { IPolicyRecordTypeInput } from '@/modules/Policy/interfaces/policy-form'
import { Case } from '@/modules/Case/interfaces/case'
import { Quote } from '@/modules/Quote/interfaces/quote'

@Component({
  components: {
    AppTextSearch
  }
})
export default class PolicyFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IPolicyRecordTypeInput }) value!: IPolicyRecordTypeInput
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote

  get disable () {
    return !!this.caseInfo || !!this.quote
  }

  mounted () {
    this.getRecordTypes(RecordTypeMaster.POLICY)
  }

  recentlyClickHandler (index: number) {
    if (this.disable) {
      return
    }
    const recordType = this.recentlyUsedRecordTypes[index]
    this.candidateRecordTypes.push()
    const findIndex = this.candidateRecordTypes.findIndex(rt => rt.name === recordType.name)
    if (findIndex === -1) {
      this.candidateRecordTypes = [...this.candidateRecordTypes, recordType]
    }
    this.value.recordType = {
      name: recordType.name,
      id: +recordType.id
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
